import getMapData from "./_getMapData.js";
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}
export {
  mapCacheGet as default
};
//# sourceMappingURL=_mapCacheGet.js.map
